//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { Serialized } from '@utils/types/Serialized';
import { ICampaign } from '@apis/campaigns/campaignsApiModel';

export const deserializeCampaign = (
  campaign: Serialized<ICampaign>,
): ICampaign => ({
  ...campaign,
  start: new Date(campaign.start),
  end: new Date(campaign.end),
});
